import React from 'react'
import { useNavigate } from 'react-router-dom'

function StudyPlannerPop({ assessmentData, setAssessmentData, isSetOpenPopUp }) {
    return (
        <div className="ContainerSubmitedSucess ">
            <div className="SubContainerSubmitedSucess">
                {/* Add message alert image */}
                <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "20px" }}>
                    <img src="/images/alert.svg" alt="" />
                </div>
                <div className="mt-4" style={{ fontSize: "30px", textAlign: "center", fontWeight: "600" }}>
                    {assessmentData}
                </div>
                {/* <div>Do you want to Start Assessment Now?</div> */}
                <div className="d-flex justify-content-around align-items-center mt-5 widthOfContainer">
                    <button
                        className="okayBtnsucess"
                        onClick={() => {
                            isSetOpenPopUp(false)
                        }}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    )
}

export default StudyPlannerPop